import Vue from 'vue'
export const message = {
    requried: 'This is a required field.',
    integer: 'Value field must be integers.',
}
export const generalAddressFormat = (data) => {
    let stringAddress = ''
    let strOne = ''
    let strTow = ''
    let strThree = ''
    strOne += data.street_no && data.street_name ? data.street_no + ' ' + data.street_name :
        data.street_no && !data.street_name ? ' ' + data.street_no :
        !data.street_no && data.street_name ? ' ' + data.street_name : ''
    strTow += data.unit_no && data.building_name ? ', ' + data.unit_no + ' ' + data.building_name :
        data.unit_no && !data.building_name ? ', ' + data.unit_no :
        !data.unit_no && data.building_name ? ', ' + data.building_name : ''
    strThree += data.country && data.postal_code ? ', ' + data.country + ' ' + data.postal_code :
        data.country && !data.postal_code ? ', ' + data.country :
        !data.country && data.postal_code ? ', ' + data.postal_code : ''
    stringAddress = strOne + strTow + strThree
    if (stringAddress.substr(0, 1) == ',')
        stringAddress = stringAddress.replace(',', '')
    stringAddress = stringAddress.trim()
    return stringAddress;
}
export const defineStampInsertPdf = {
    position_x: 250,
    position_y: -150,
    border: {
        border_type: 'roundedRect', // rect
        border_color: [
            0,
            102, 
            153
        ],
        border_width_01: 80,
        border_height_01: 44,
        border_radius_01: 5,
        border_width_02: 86,
        border_height_02: 50,
        border_radius_02: 8,
    },
    text: {
        color: '5659ff',
        font_family: 'Helvetica',
        font_weight: 'normal',
    },
    lines: [
        {
            text: '__A__ __DATE__',
            text_style: {
                font_size: 14,
                line_height: 14,
                font_weight: 'bold',
            },
        },
        {
            text: '__B__ / __C__',
            text_style: {
                font_size: 14,
                line_height: 14,
                font_weight: 'bold',
            },
        },
        {
            text: 'To: GM __D__',
            text_style: {
                font_size: 12,
                line_height: 12,
                font_weight: 'normal',
            },
        },
        {
            text: 'We confirm the completion of work(s),',
            text_style: {
                font_size: 12,
                line_height: 12,
                font_weight: 'normal',
            },
        },
        {
            text: 'please issue Works Order.',
            text_style: {
                font_size: 12,
                line_height: 16,
                font_weight: 'normal',
            },
        },
        {
            text: 'on behalf of  GM (EMS)',
            text_style: {
                font_size: 12,
                line_height: 12,
                font_weight: 'normal',
            },
        }, {
            text: 'EM Services Pte Ltd',
            text_style: {
                font_size: 12,
                line_height: 16,
                font_weight: 'normal',
            },
        },
    ]
}
export const notificationV2 = (keyMessage, message) => {
    let noti = {
        adding: 'Successfully added ',
        editing: 'Successfully updated ',
        deleting: 'Successfully deleted ',
        existing: ' already exists',
        importing: 'Successfully imported ',
        assigning: 'Successfully assigned ',
        clone: 'Successfully clone ',
        schedule: 'Successfully scheduled'
    }
    let msg = {
        gl_manual: 'General Ledger',
        case: 'Case',
        order: 'Order',
        ap_invoice: 'AP Invoice',
        liquidated_damages: 'Liquidated Damages',
        payment_voucher: 'Payment Voucher',
        line_item: 'Line Item',
        approval: 'Approval',
        delivery_log: 'Delivery Log',
        activity_log: 'Activity Log',
        attachment: 'Attachment',
        misc_expenses: 'Misc Expense',
        client_contract: 'Client Contract',
        client_contract_setting: 'General settings',
        supplier_contract: 'Supplier Contract',
        vendor_linking: 'Vendor Linking',
        vendor_linking_sor: 'Vendor Linking SOR',
        vendor_linking_service: 'Vendor Linking Service Category',
        vendor_linking_property: 'Vendor Linking Property',
        service_category: 'Service Category',
        fault_type: 'Fault Type',
        sla: 'SLA',
        priority: 'Priority',
        property: 'Property',
        location: 'Location',
        equipment: 'Equipment',
        equipment_structure: 'Equipment Structure',
        equipment_group_custom_field: 'Custom Field',
        master_equipment_structure: 'Master Equipment Structure',
        brand: 'Brand',
        model: 'Model',
        sor: 'SOR',
        sor_group: 'SOR Grouping',
        job_list: 'Job List',
        frequency: 'Frequency',
        adjustment: 'Price Adjustment',
        department_code: 'Department Code',
        fm_code_finance: 'Finance Info',
        fm_code: 'FM Code',
        head_lease: 'Head Lease',
        approval_template: 'Approval Template',
        approval_template_master: 'Master Approval Template',
        approval_template_master_item: 'Master Approval Template Level',
        checklist_template: 'Checklist Template',
        checklist: 'Checklist',
        client_staff: 'Client Staff',
        supplier_staff: 'Supplier Staff',
        fm_officer: 'FM Officer',
        posting_rule: 'Posting Rule',
        navision_file: 'Navision File',
        gl_account_name: 'GL Account Name',
        transaction_type: 'Transaction Type',
        issue_register: 'Issue Register',
        supplier: 'Supplier',
        reference: 'Reference',
        company: 'Company',
        user: 'User',
        user_duty: 'User Duty',
        metering_device: 'Metering Device',
        meter_reading: 'Meter Reading',
        reading_log: 'Reading Log',
        app_version: 'App Version',
        chart_of_account: 'Chart Of Account',
        column_setting: 'Column Setting',
        tax: 'Tax',
        navision_setting: 'Navision Setting',
        requestor: 'Requestor ',
        room_inventory: 'Room Inventory',
        room_inventory_set: 'Room Inventory Set',
        maintenance_program: 'Maintenance Program',
        maintenance_standard: 'Maintenance Standard',
        maintenance_schedule: 'Maintenance Schedule',
        preventive_maintenance: 'Preventive Maintenance', //only equipment
        tenant_site: 'Tenant Site',
        roles_authorisation: 'Roles and Authorisation',
        asset_management: 'Lift Inspection Scheduling',
        parts_replacement_history: 'Part Replacement History',
        batch_submission_summary: 'Batch Submission Summary',
        batch_submission_summary_detail: 'Batch Submission Summary Detail',
        incoming_documents: 'Incoming Documents',
        parts_replacement: 'Part Replacement',
        job_work_finding: 'Work Findings',
        password_management: 'Password Management',
        budget_header: 'Budget Header',
        budget_entries: 'Budget Entries',
        setting_lift_inspection_report: 'Settings - Lift Inspection Report',
        back_date_job: 'Back date jobs',
        property_versioning: 'Property Versioning',
        notification_templates: 'Notification Tempplates',
        nature_of_feedback: 'Nature Of Feedback',
        operating_hour_type: 'Operating hour type',
        operating_hour: 'Operating hour',
        case_requestor_types: 'Requestor Type',
        filters:'Filters',
        case_setting_custom_fields: 'Case Settings - Custom Fields',
        escalation: 'Escalation',
        vendor_linking_creditor_code: 'Vendor Linking Creditor Code',
        job_list_soft_fm: '6 monthly safety hazard inspection scheduling',
        case_requestor_company: 'Requestor Company',
        email_status:"Email Status",
        supplier_finance: 'Finance',
        pa_contract_sum: 'Contract Sum',
        pa_maintenance_weight: 'Maintenance Type Weightage',
        contact_site: 'Contact Site',
        defect_report: 'Approval Request',
        defect_report_item: 'Approval Request Line Item',
        lmu_invoice: 'LMU Invoice',
        lmu_dorj: 'LMU DORJ',
        nlt_address_book: 'NLT Address Book',
        master_brand: 'Master Brand',
        supplier_contactable_emails: 'Contactable Email',
        electricity_meter: 'Electricity Meter',
        electricity_reading_logs: 'Electricity Reading Logs',
        s_contract_schedule: 'job inspection',
        s_contract_schedule_import: 'WSH Safely inspection',
        s_contract_project: 'Project Listing',
        order_service_report: "Service Report",
        action_taken: "Action Taken",
        credit_note: "Credit Note",
        nlt_mailing_list: 'NLT Mailing List Management',
        schedule_job: 'Schedule Job',
        safe_inspection_checklist: 'Safety Inspection Checklist',
        safe_inspection_checklist_work_finding: 'Infringement',
        safe_inspection_checklist_action_taken: 'Action Taken',
        permit_to_work: 'Permit To Work',
        non_conformance_report: 'Non Conformance Report',
        safe_induction_training_briefing: 'Briefing Record',
        safe_induction_training_training: 'Training Schedule',
        toolbox_meeting: 'Toolbox Meeting',
        safety_worker: 'Worker',
        vendor_linking_equipment: 'Vendor Linking Equipment',
        safety_suppliers: 'Safety Supplier',
        resident_site: 'Resident Site',
    }
    let customMsg = {
        user_duty_assign: "Duties assigned successfully"
    };
    if (keyMessage === 'custom') {
        return customMsg[message];
    }

    if (keyMessage === 'existing') {
        return `${msg[message]} ${noti[keyMessage]}`;
    }
    return `${noti[keyMessage]} ${msg[message].toLowerCase()}`;
}

export const formatDateLift = "DD-MMM-YYYY";

export const fileIcons = {
    'application': {
        'word': {
            'img': 'word.png',
            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
        },
        'excel': {
            'img': 'excel.png',
            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
        },
        'pdf': {
            'img': 'pdf.png',
            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
        },
        'text': {
            'img': 'notepad.png',
            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
        },
    },
    'image': {
        'img': 'image.png',
        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
    },
    'text': {
        'img': 'notepad.png',
        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
    },
    'inode': 'none'
}

export const validationData = (validate_fields, data) => {
    const vm = new Vue()
    let flag = false
    for (const field of validate_fields) {
        if(!data[field.key] || (Array.isArray(data[field.key]) && data[field.key].length === 0)) {
            flag = true
            vm.$alertNotification(`${field.name} is required`, "danger");
            break
        }
    }

    return flag
}